export const REMINDER_PRESETS = ["tomorrow_9am", "next_monday_9am", "first_of_next_month_9am"] as const;
export type ReminderPreset = typeof REMINDER_PRESETS[number];

export const RECURRENCE_RULES = ["daily", "weekdays", "weekly", "biweekly", "monthly", "yearly"] as const;
export type RecurrenceRule = typeof RECURRENCE_RULES[number];

export const ENTITY_TYPES = ["company", "contact", "deal", "task", "activity", "email"] as const;
export type ReminderEntityType = typeof ENTITY_TYPES[number];

export interface CreateReminderRequest {
  title: string;
  note?: string;
  preset?: ReminderPreset;
  customDateTime?: string; // naive local datetime string from datetime-local input
  scheduledFor?: string;   // ISO UTC, alternative to preset/custom
  entityType?: ReminderEntityType | null;
  entityId?: string | null;
  emailMicrosoftId?: string | null;
  emailWebLink?: string | null;
  emailSubject?: string | null;
  emailFrom?: string | null;
  assignedToId?: string;        // defaults to creator
  recurrenceRule?: RecurrenceRule | null;
  recurrenceEndDate?: string | null; // ISO UTC
}

export interface SnoozeRequest {
  duration: "1h" | "1d" | string; // string variant = ISO UTC
}

export const PRESET_LABELS: Record<ReminderPreset, string> = {
  tomorrow_9am: "Tomorrow 9 AM",
  next_monday_9am: "Next Monday 9 AM",
  first_of_next_month_9am: "1st of next month 9 AM",
};
